/**
 * PostHog Analytics Events for Rainmaker (AI-powered task suggestions)
 * Tracks: Suggestion views, execution, dismissal, navigation, evidence viewing
 */

// Event names
export const RAINMAKER_EVENTS = {
  // Suggestion lifecycle
  SUGGESTION_VIEWED: 'rainmaker_suggestion_viewed',
  SUGGESTION_EXECUTED: 'rainmaker_suggestion_executed',
  SUGGESTION_DISMISSED: 'rainmaker_suggestion_dismissed',

  // Navigation
  SUGGESTION_NAVIGATED: 'rainmaker_suggestion_navigated',

  // Evidence interactions
  EVIDENCE_VIEWED: 'rainmaker_evidence_viewed',
  EXECUTION_MODAL_OPENED: 'rainmaker_execution_modal_opened',

  // Restore flow
  SUGGESTIONS_RESTORED: 'rainmaker_suggestions_restored',

  // Completion state
  COMPLETED_STATE_VIEWED: 'rainmaker_completed_state_viewed',
} as const;

// Property names
export const RAINMAKER_PROPERTIES = {
  // Common
  MATTER_ID: 'matter_id',
  TASK_ID: 'task_id',
  PAGE: 'page',
  COMPONENT: 'component',

  // Suggestion properties
  SUGGESTION_ID: 'suggestion_id',
  SUGGESTION_TITLE: 'suggestion_title',
  SUGGESTION_GENERATOR: 'suggestion_generator',
  SUGGESTION_STATUS: 'suggestion_status',

  // Navigation properties
  DIRECTION: 'direction', // 'prev' | 'next'
  CURRENT_INDEX: 'current_index',
  TOTAL_SUGGESTIONS: 'total_suggestions',

  // Action properties
  ACTION_COUNT: 'action_count',

  // Evidence properties
  EVIDENCE_COUNT: 'evidence_count',
  EVIDENCE_TYPES: 'evidence_types', // array of evidence type strings

  // Status properties
  STATUS: 'status', // 'active' | 'done' | 'ignored'
  EXECUTED_SUGGESTION_COUNT: 'executed_suggestion_count',
  DISMISSED_SUGGESTION_COUNT: 'dismissed_suggestion_count',
} as const;

// Type helpers
export type RainmakerEvent =
  (typeof RAINMAKER_EVENTS)[keyof typeof RAINMAKER_EVENTS];
export type RainmakerProperty =
  (typeof RAINMAKER_PROPERTIES)[keyof typeof RAINMAKER_PROPERTIES];
